import React from "react";
import addtask from "../../../../assets/img/admin/pana1.svg";
import question from "../../../../assets/img/admin/pana.svg";
import arrowLeft from "../../../../assets/img/admin/arrow-left-white.svg";
import Button from "../../../shared/Button";
import { useNavigate } from "react-router-dom";

const AdminAddFaq = () => {
  const navigate = useNavigate()
  return (
    <div className="AdminAddFaq">
      <h2 className="text-[36px] font-[700] text-[#12171C] mb-[20px]">
        افزودن سوالات متداول
      </h2>
      <div className="AdminAddFaq-box flex justify-between">
        <img src={addtask}  />
        <div>
          <h4>برای سهولت کاربر سوال متداول وارد نمایید</h4>
          <p>
            در واقع صفحه FAQ یکی از معدود صفحات این لیست پیش‌فرض است که باید
            حتماً برروی وبسایت خود داشته باشید. به صفحه FAQ به چشم یک صفحه خدمات
            مشتریان اتوماتیک سازی شده یا یک دفترچه راهنمای محصول ساده سازی شده
            نگاه کنید. جایی که کاربران می‌توانند پاسخ‌های مرتبط با محصولات مختلف
            را بدون این که نیاز باشد از کسی بپرسند، خودشان پیدا کنند.
          </p>
        </div>
        <Button onClick={()=>navigate("/admin/Faq-form")} varient="primary">
          <div className="flex gap-[6px]">
            <div>     افزودن سوالات متداول</div>
            <img src={arrowLeft}/>

          </div>
        </Button>
      </div>
      <h2 className="text-[36px] font-[700] text-[#12171C] mt-[40px] mb-[20px]">
      لیست سوالات متداول
      </h2>
      <div className="AdminAddFaq-box flex justify-between">
        <img src={question} />
        <div>
          <h4>لیست خود را ببنید</h4>
          <p>
          این بخش مربــوط به مــحتوایی هســــت که قبلا ســــاخته اید که مـــی تـــوانید آن هـــا را بـــرسی ، بروز رسانی و حتی حـــذف بــنــمــایــیــد
          </p>
        </div>
        <Button  onClick={()=>navigate("/admin/Faq-list")}  varient="primary">
        <div className="flex gap-[6px]">
            <div>لیست سوالات متداول</div>
            <img src={arrowLeft}/>

          </div>
        </Button>
      </div>
    </div>
  );
};

export default AdminAddFaq;
